module.exports = __webpack_public_path__ + "img/Group_1357@2x.65bb66c8.png";